module.exports = __webpack_public_path__ + "static/media/app-logo.3f9a33d9.png";